import { create } from 'zustand';
import { presenceService, SessionData } from '../services/crdt/presenceService';

export type { SessionData };

interface PresenceState {
  sessions: Record<string, SessionData>;
  isConnected: boolean;
  currentUser: any;
}

interface PresenceActions {
  connect: (spaceId: string, user: any) => () => void;
  updateCursor: (x: number, y: number) => void;
  disconnect: () => void;
}

type PresenceStore = PresenceState & PresenceActions;

export const usePresenceStore = create<PresenceStore>((set, get) => ({
  sessions: {},
  isConnected: false,
  currentUser: null,

  connect: (spaceId: string, user: any) => {
    set({ currentUser: user, isConnected: true });

    const disconnect = presenceService.connect(spaceId, (sessions) => {
      set({ sessions });
    });

    return () => {
      disconnect();
      set({ isConnected: false, sessions: {} });
    };
  },

  updateCursor: (x: number, y: number) => {
    const { currentUser, isConnected } = get();
    if (!isConnected || !currentUser) return;
    presenceService.updateCursor(x, y, currentUser);
  },

  disconnect: () => {
    presenceService.disconnect();
    set({ isConnected: false, sessions: {}, currentUser: null });
  },
}));

export { presenceService };
